import React, { useEffect } from "react";

// UTM helper functions
const getUtmParamsFromUrl = (url) => {
  const params = new URLSearchParams(url.search);
  return {
    gclid: params.get("gclid"),
    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_content: params.get("utm_content"),
    utm_term: params.get("utm_term"),
  };
};

//updated getcookie function
function getCookieValue(name) {
  if (typeof document === "undefined") return null; // check for browser
  const nameEQ = name + "=";
  const ca = document.cookie.split(";"); // Splits into an array of "key=value" strings
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length); // Removes leading spaces from *each* cookie part
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

const DriftLoader = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const urlParams = new URLSearchParams(window.location.search);
      const disableDrift =
        urlParams.has("DisableDrift") &&
        urlParams.get("DisableDrift") === "true";

      if (!disableDrift && window.drift === undefined) {
        // Properly formatted IIFE for Drift initialization
        (function () {
          var t;
          t = window.drift = window.driftt = window.driftt || [];
          if (!t.init) {
            t.invoked = !0;
            t.methods = [
              "identify",
              "config",
              "track",
              "reset",
              "debug",
              "show",
              "ping",
              "page",
              "hide",
              "off",
              "on",
            ];
            t.factory = function (e) {
              return function () {
                var n = Array.prototype.slice.call(arguments);
                n.unshift(e);
                t.push(n);
                return t;
              };
            };
            t.methods.forEach(function (e) {
              t[e] = t.factory(e);
            });
            t.load = function (t) {
              var e = 3e5,
                n = Math.ceil(new Date() / e) * e,
                o = document.createElement("script");
              o.type = "text/javascript";
              o.async = !0;
              o.crossorigin = "anonymous";
              o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
              var i = document.getElementsByTagName("script")[0];
              i.parentNode.insertBefore(o, i);
            };
          }
        })();

        // Load the Drift bot
        window.drift.SNIPPET_VERSION = "0.3.1";
        window.drift.load("dvzy9khhkeme");
        window.drift.on("ready", function (api) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "driftReady",
          });

          // UTM logic initialization
          let gclidValue = "";
          let utmSource = "";
          let utmMedium = "";
          let utmCampaign = "";
          let utmContent = "";
          let utmTerm = "";

          // get UTMs from URL
          const urlUtms = getUtmParamsFromUrl(window.location);

          if (urlUtms.gclid) gclidValue = urlUtms.gclid;
          if (urlUtms.utm_source) utmSource = urlUtms.utm_source;
          if (urlUtms.utm_medium) utmMedium = urlUtms.utm_medium;
          if (urlUtms.utm_campaign) utmCampaign = urlUtms.utm_campaign;
          if (urlUtms.utm_content) utmContent = urlUtms.utm_content;
          if (urlUtms.utm_term) utmTerm = urlUtms.utm_term;

          // otherwise, fill empty UTMs from Cookie
          const campaignUrl = getCookieValue("__gtm_campaign_url");
          const referrerCookie = getCookieValue("__gtm_referrer");

          if (campaignUrl) {
            try {
              // Assuming cookie value is a JSON string of standard UTM names
              const parsedCookieData = JSON.parse(
                decodeURIComponent(campaignUrl)
              );

              // Merge, URL params take precedence (only if variable is still empty)
              if (parsedCookieData.gclid && !gclidValue)
                gclidValue = parsedCookieData.gclid;
              if (parsedCookieData.utm_source && !utmSource)
                utmSource = parsedCookieData.utm_source;
              if (parsedCookieData.utm_medium && !utmMedium)
                utmMedium = parsedCookieData.utm_medium;
              if (parsedCookieData.utm_campaign && !utmCampaign)
                utmCampaign = parsedCookieData.utm_campaign;
              if (parsedCookieData.utm_content && !utmContent)
                utmContent = parsedCookieData.utm_content;
              if (parsedCookieData.utm_term && !utmTerm)
                utmTerm = parsedCookieData.utm_term;
            } catch (e) {
              console.error("Error parsing GTM campaign cookie:", e);
            }
          } else if (referrerCookie) {
            try {
              // Assuming cookie value is a JSON string of standard UTM names
              const parsedReferrerCookieData = JSON.parse(
                decodeURIComponent(referrerCookie)
              );

              // Merge, URL params take precedence (only if variable is still empty)
              if (parsedReferrerCookieData.gclid && !gclidValue)
                gclidValue = parsedReferrerCookieData.gclid;
              if (parsedReferrerCookieData.utm_source && !utmSource)
                utmSource = parsedReferrerCookieData.utm_source;
              if (parsedReferrerCookieData.utm_medium && !utmMedium)
                utmMedium = parsedReferrerCookieData.utm_medium;
            } catch (e) {
              console.error("Error parsing GTM referrer cookie:", e);
            }
          }

          // add any UTMs to object
          const utmAttributes = {
            ...(gclidValue && { gclid: gclidValue }),
            ...(utmSource && { custom_recent_utm_source: utmSource }),
            ...(utmMedium && { custom_recent_utm_medium: utmMedium }),
            ...(utmCampaign && { custom_recent_utm_campaign: utmCampaign }),
            ...(utmContent && { custom_recent_utm_content: utmContent }),
            ...(utmTerm && { custom_recent_utm_term: utmTerm }),
          };

          // Send UTMs to Drift
          if (Object.keys(utmAttributes).length > 0) {
            api.setUserAttributes(utmAttributes);
          }
        });
      }
    }
  }, []);

  return null;
};

export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <DriftLoader />
  </>
);

// export const onClientEntry = () => {
//   if (typeof window !== "undefined") {
//     const urlParams = new URLSearchParams(window.location.search);
//     const disableGTM = urlParams.has("disableGTM");

//     if (!disableGTM) {
//       const gtmScript = document.createElement("script");
//       gtmScript.async = true;
//       gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=GTM-N5C6H2D"; // Replace with your GTM ID
//       document.head.appendChild(gtmScript);

//       // Optionally inject the data layer
//       window.dataLayer = window.dataLayer || [];
//       window.dataLayer.push({
//         event: "gtm.js",
//         "gtm.start": new Date().getTime(),
//       });
//     }
//   }
// };

export const onRouteUpdate = ({ location }) => {
  if (typeof window.drift !== "undefined") {
    // Ensure Drift tracks the page change
    window.drift.page();
  }
};
